import React, { FC, useState } from "react";
import {
  styled,
  InputBase,
  InputLabel,
  Box,
  Button,
  Card,
  CardHeader,
  CardContent,
  Grid,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { useFormContext, useFieldArray, Controller } from "react-hook-form";
import { FormCard, FormText, FormTextMultiLine } from "../../template";
import {
  validateDefault,
  validateName,
  validateMail,
  validateCheckBox,
} from "../../components/validation";
import { timeCurrentIso8601 } from "../../utils";
import { DispHikkou } from "../../template/DispHikkou";
import { getValue } from "@testing-library/user-event/dist/utils";
export const ContactForm = (props: any) => {
  const { open, onClose, onSubmit } = props;
  const [consent, setConsent] = useState(false);
  const methods = useFormContext();

  console.log(methods.formState.errors);
  return (
    <>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <DialogTitle textAlign="center" fontWeight={900} fontSize={40}>
          お問い合わせ
        </DialogTitle>
        <DialogContent sx={{ padding: 1 }}>
          <Stack spacing={1} padding={0}>
            <Grid container spacing={0.1}>
              <Grid item md={12} xs={12}>
                <FormCard
                  title={
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      {"会社名・組織"}
                      <DispHikkou />
                    </Box>
                  }
                  description=""
                  child={
                    <FormText
                      label="会社名"
                      name="cp"
                      validate={validateDefault}
                    />
                  }
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <FormCard
                  title={
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      {"氏名"}
                      <DispHikkou />
                    </Box>
                  }
                  description=""
                  child={
                    <FormText
                      label="例:蔡温太郎"
                      name="username"
                      validate={validateName}
                    />
                  }
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <FormCard
                  title={
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      {"メールアドレス"}
                      <DispHikkou />
                    </Box>
                  }
                  description=""
                  child={
                    <FormText
                      label="例:taro@syon.co.net"
                      name="mail"
                      validate={validateMail}
                    />
                  }
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <FormCard
                  title={
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      {"電話番号"}
                      <DispHikkou />
                    </Box>
                  }
                  description=""
                  child={
                    <FormText
                      label="日中繋がりやすい電話番号"
                      name="tel"
                      validate={validateDefault}
                    />
                  }
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <FormCard
                  title="お問い合わせ内容"
                  description=""
                  child={<FormTextMultiLine label="任意" name="detail" />}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    maxWidth: "md",
                    paddingTop: 2,
                    paddingLeft: 8,
                    paddingRight: 8,
                  }}
                >
                  <input
                    type="checkbox"
                    value={timeCurrentIso8601() as string}
                    defaultChecked={consent}
                    disabled={consent}
                    {...methods.register("consent_date", {
                      required: !(methods.getValues("consent_date").length > 0),
                    })} // 追記
                  />
                  <Box sx={{ paddingLeft: 2, textAlign: "left" }}>
                    個人情報の取り扱いに関しては
                    <a
                      href={`https://www.syon.co.jp/about/%e3%83%97%e3%83%a9%e3%82%a4%e3%83%90%e3%82%b7%e3%83%bc%e3%83%9d%e3%83%aa%e3%82%b7%e3%83%bc/`}
                      target="_blank"
                    >
                      プライバシーポリシー
                    </a>
                    についてをお読みいただき、同意のうえお問い合わせください。
                  </Box>
                </Box>
                <Box
                  sx={{
                    paddingLeft: 8,
                    textAlign: "left",
                    color: "rgba(236,105,54,10)",
                    fontFamily: "Hiragino Sans",
                  }}
                >
                  {consent == false && "※必須"}
                </Box>
              </Grid>
            </Grid>
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{
            textAlign: "center",
            WebkitBoxAlign: "center",
            WebkitBoxPack: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ "& button": { m: 1 }, paddingBottom: 5 }}>
            <Button
              variant="outlined"
              sx={{
                minWidth: 150,
                minHeight: 35,
                padding: 1,
                margin: 1,
                fontSize: 20,
              }}
              onClick={onClose}
            >
              キャンセル
            </Button>
            <Button
              sx={{
                minWidth: 150,
                minHeight: 35,
                padding: 1,
                margin: 2,
                fontSize: 20,
              }}
              type="submit"
              variant="contained"
            >
              送 信
            </Button>
          </Box>
        </DialogActions>
      </form>
    </>
  );
};
